<template>
  <BaseGrid class="dreamGrid">
    <!-- Chart -->
    <DestinationPickerChart
      :chart-data="searchParams.chartData"
      @update:chart-data="onChartUpdate"
    />
    <!-- Card List -->
    <DestinationPickerCardList
      class="w-full"
      :user-preference="searchParams.chartData"
      :items="$breakpoints.lSm ? apiData?.slice?.(0, 2) : apiData"
      :transition="$breakpoints.sMd && searchParams.page === 1 ? 'fade-fast' : ''"
      :pending="pending"
    />

    <!-- Card list -->
    <template v-if="$breakpoints.lSm">
      <DestinationPickerCardListItem
        v-for="(item, i) in apiData?.slice?.(2, apiData.length)"
        :key="item.country_id"
        :item="item"
        :index="i + 3"
        :user-preference="searchParams.chartData"
      />
    </template>
  </BaseGrid>
</template>

<script setup>
import { ConnectApi } from '@js/plugins/connectApi';
import BaseGrid from '../Base/BaseGrid.vue';

const { searchParams, apiData, pending } = useDestinationPickerData();

function useDestinationPickerData () {
	const defaultChartData = Array.from({ length: 8 }, () => 98);

	const urlParams = new URLSearchParams(window.location.search);

	const searchParams = reactive({
		chartData: urlParams.get('chartData')
			? urlParams.get('chartData').split(',').map(v => Number(v))
			: defaultChartData
	});

	const pending = ref(false);
	const apiData = shallowRef(js_params.destinationPicker);

	watch(() => searchParams.chartData, () => {
		updateUrl();
		getData();
	}, { immediate: true, deep: true });

	async function getData () {
		if (pending.value) {
			return;
		}
		pending.value = true;
		const apiResponse = await ConnectApi('DestinationPicker', 'search', searchParams);
		apiData.value = apiResponse?.length ? apiResponse : [];
		pending.value = false;
	}

	function refresh () {
		getData();
	}

	function updateUrl () {
		const params = new URLSearchParams();
		params.set('chartData', searchParams.chartData.join(','));
		const newUrl = `${window.location.pathname}?${params.toString()}`;
		window.history.replaceState({}, '', newUrl);
	}

	return {
		searchParams,
		apiData,
		refresh,
		pending,
		getData
	};
}

// Chart callback
function onChartUpdate (chartData) {
	searchParams.chartData = chartData;
}
</script>


<style scoped>
.dreamGrid {
  grid-template-columns: 50% 50%;
  padding: 1rem;
  padding-bottom: 3rem;
}
@media (max-width:767.8px) {
  .dreamGrid {
    grid-template-columns: 100%;
  }
}
.img {
  border-radius: 0 .3rem 0 0;
  height: 100%;
  object-fit: cover;
  width: 100%;
}
</style>
